import { AlertItem } from './AlertItem';
import type { Alert } from '@/lib/api/dashboard';

// Data-quality gaps that silently disable other features (CR #77) — each row
// links straight to the record missing the field. Hides itself when clean.
export const NeedsAttentionPanel = ({ items }: { items: Alert[] }) => {
  if (items.length === 0) return null;
  return (
    <div className="flex flex-col gap-4">
      <div className="flex items-center justify-between">
        <h2 className="text-xl font-bold leading-tight tracking-[-0.015em] text-gray-900">
          Needs Attention
        </h2>
        <span className="flex h-6 min-w-6 items-center justify-center rounded-full bg-warning/10 px-2 text-xs font-bold text-warning">
          {items.length}
        </span>
      </div>
      <p className="-mt-2 text-xs text-gray-500">Missing data that quietly disables invoicing, budget alerts, or labour costing.</p>
      <div className="flex flex-col gap-3">
        {items.map(item => (
          <AlertItem key={item.id} {...item} />
        ))}
      </div>
    </div>
  );
};
